import '../index.css';

const ProgressBar = ({ progressPercentage }) => {
  return (
    <div className='h-1 w-full bg-gray-300'>
        <div
            style={{ width: `${progressPercentage}%`}}
            className={`h-full ${
                progressPercentage < 70 ? 'bg-red-600' : 'bg-green-600'}`}>
        </div>
    </div>
  );
};

export default ProgressBar;

// https://dev.to/ms_yogii/simple-progress-bar-component-in-react-with-tailwind-i6a